// extracted by mini-css-extract-plugin
export var fullHeightState = "_1v-7";
export var headerCell = "_1v-1";
export var loadingStateCell = "_1v-4";
export var rowWrapper = "_1v-3";
export var standaloneTable = "_1v-8";
export var standaloneTableWithBodyFill = "_1v-9";
export var stateCell = "_1v-5";
export var table = "_1v-0";
export var tableBodyFiller = "_1v-6";
export var white = "_1v-2";